<template>
  <pl-dialog
    :title="'Disconnect Course'"
    :size="'sm'"
    :disableOutsideClick="true"
    @close="closeModal"
  >
    <div class="flex flex-col flex-grow justify-center">
      <div class="flex flex-row mx-auto items-center">
        <img
          :src="`/static/integrations/${integration.name}.png`"
          class="h-12 w-12 rounded-full"
        />
        <img src="/static/pass_through.svg" class="mx-10 h-7" />
        <img
          src="/static/logos/parlay_logo.svg"
          alt="parlay-logo"
          class="h-12 w-12"
        />
      </div>
      <div class="flex mt-10 mx-auto">
        <pl-checkbox v-model="removeStudents" />
        <span> Also remove students from course </span>
      </div>
      <div class="flex items-center justify-center h-5">
        <div v-show="removeStudents" class="text-red-500 font-medium">
          Removing students will permanently delete all of their activity in the
          Course.
        </div>
      </div>
    </div>
    <div class="mt-10 mb-5 mx-auto">
      <button
        class="px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-400 font-semibold"
        @click="closeModal"
      >
        Cancel
      </button>
      <button
        class="px-8 py-2 bg-red-400 rounded cursor-pointer text-white font-semibold"
        @click="disconnectIntegrationCourse"
      >
        Disconnect
      </button>
    </div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        removeStudents: false,
      };
    },
    props: {
      integration: {
        type: Object,
        default: '',
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getRoleInCourse',
        'getCourseLayoutFullScreenStatus',
      ]),
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      disconnectIntegrationCourse() {
        const course_id = this.$route.params.courseID;
        const integration_id = this.integration.integration_id;
        this.$store
          .dispatch('unsyncIntegrationCourse', {
            course_id,
            integration_id,
            remove_students: this.removeStudents,
          })
          .then(() => {
            this.closeModal();
          })
          .catch((err) => {
            this.loading_to_disconnect = false;
            console.error(err);
          });
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// disconnectIntegrationModal.vue?83ee5616